import { watch, ref, computed } from '@vue/composition-api';

export const useLinkTemplate = ({ props, root }) => {
  const companyId = computed(() => root.$store.state.company.currentId);
  const segmentId = computed(() => root.$store.state.company.segment.currentId);
  const currentTemplate = computed(() =>
    root.$store.state.company.segment.templates.list.find(
      (t) => t.id === props.templateId
    )
  );
  const duplicateLink = ref(null);
  const fetchingLink = ref(false);
  const template = (() => {
    if (root.$route.params.link) {
      const link = root.$route.params.link;
      return ref({
        ...link,
        campaign: link.campaign.id,
      });
    }
    if (props.linkId) {
      return duplicateLink;
    }
    if (props.templateId) {
      return currentTemplate;
    }
    return ref(null);
  })();

  const fetchLink = async () => {
    if (!props.linkId || !companyId.value || !segmentId.value) {
      duplicateLink.value = null;
      return;
    }
    fetchingLink.value = true;
    const { data } = await root.$api.get(
      `companies/${companyId.value}/segments/${segmentId.value}/tracking_links/${props.linkId}/`
    );
    fetchingLink.value = false;
    duplicateLink.value = {
      ...data,
      campaign: data.campaign.id,
    };
  };

  watch(() => props.linkId, fetchLink);

  return { template, fetchingTemplate: fetchingLink };
};
